const STAGE = process.env.NEXT_PUBLIC_STAGE as string;
const GITHUB_COMMIT_SHA = process.env
  .NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA as string;

//TODO: make the snake_case ones into camelCase
interface Stage {
  amplitudeApiKey: string;
  awsRegion: "us-east-1";
  cognitoUserPoolId: string;
  cognitoUserPoolWebClientId: string;
  api_url: string;
  collectorUrl: string;
  collectorHeaders?: { [key: string]: string };
  honeycomb_api_key: "749ee39c9c51e52408007cd74f98942c";
  honeycomb_dataset: "staging" | "prod";
  google_analytics_enabled: boolean;
  google_recaptcha_key: "6Lc9XBgsAAAAAGQXaArBUiD0uFV1FaVmZ6WJF0EZ";
  stripePublishableKey: string;
  gitCommitSha: string;
}

const settings: { [index: string]: Stage } = {
  staging: {
    amplitudeApiKey: "9f8f9725291885004d1cb9f453ab7feb",
    awsRegion: "us-east-1",
    cognitoUserPoolId: "us-east-1_cWcTBZ2OY",
    cognitoUserPoolWebClientId: "2plujbabn71kg3va494ebvgftp",
    api_url:
      process.env.NEXT_PUBLIC_API_URL || "https://staging-api.flashpcb.com",
    collectorUrl: "https://collector.staging-api.flashpcb.com",
    collectorHeaders: {
      "Access-Control-Allow-Credentials": "false",
    },
    honeycomb_api_key: "749ee39c9c51e52408007cd74f98942c",
    honeycomb_dataset: "staging",
    google_analytics_enabled: false,
    google_recaptcha_key: "6Lc9XBgsAAAAAGQXaArBUiD0uFV1FaVmZ6WJF0EZ",
    stripePublishableKey:
      "pk_test_51KjpmTDp93SPggqjWt0erB5ylGqub9q3LQTX7FhT3Uolr29tfe8kSbG3jCLK85ypw8VR0VdxMOtlt4okfzfY4ZyY00VQKTRykk",
    gitCommitSha: GITHUB_COMMIT_SHA,
  },
  prod: {
    amplitudeApiKey: "0ac0ffcedb8304dd1f097b51c7828fdf",
    awsRegion: "us-east-1",
    cognitoUserPoolId: "us-east-1_GsPUrPwJJ",
    cognitoUserPoolWebClientId: "16tidrmh5j8pk5a8h43qb73snl",
    api_url: "https://api.flashpcb.com",
    collectorUrl: "https://collector.api.flashpcb.com",
    honeycomb_api_key: "749ee39c9c51e52408007cd74f98942c",
    honeycomb_dataset: "prod",
    google_analytics_enabled: true,
    google_recaptcha_key: "6Lc9XBgsAAAAAGQXaArBUiD0uFV1FaVmZ6WJF0EZ",
    stripePublishableKey:
      "pk_live_51KjpmTDp93SPggqj3YBWnZR4gZ8p5opVgIsU45n40V7Pg3Oq6mfD6GDvSoxVmLM5JxkNzeKp3zh549YrxoK3BYLL000UXEV3UD",
    gitCommitSha: GITHUB_COMMIT_SHA,
  },
};

export default settings[STAGE] as Stage;
